import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { copyToClipboard } from "../utils/clipboard";

/**
 * Copy-a-link behaviour, shared by every place that offers it. Callers supply
 * their own button so each surface keeps its own styling and theme.
 */
const useCopyLink = (url: string) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const resetTimerId = useRef<number>();

    useEffect(() => () => window.clearTimeout(resetTimerId.current), []);

    const copy = async () => {
        if (await copyToClipboard(url)) {
            setCopied(true);
            toast(t("toast.clipboard_copy"), { type: "info" });
            window.clearTimeout(resetTimerId.current);
            resetTimerId.current = window.setTimeout(
                () => setCopied(false),
                3000
            );
            return;
        }
        // The buyer can still select the link by hand, so say so rather than
        // leaving them with a button that appears to do nothing.
        toast(t("toast.clipboard_copy_failed"), { type: "error" });
    };

    return { copy, copied };
};

export default useCopyLink;
